import React from 'react';
import Range from 'rc-slider/lib/Range';

export const RangeSlider = (props) => (
	<React.Fragment>
		<p className="range-title">{props.title}</p>
		<Range 
			defaultValue={[18, 99]}
			min={18}
			max={100}
			value={[props.minValue, props.maxValue]}
			count={2}
			allowCross={false}
			handleStyle={[{
				width: '4rem', 
				height: '4rem', 
				backgroundColor: '#eef2f4', 
				border: '2px solid #3a7ebc',
				marginTop: '-1.8rem',
				marginLeft: '-2rem'
			},
			{
				width: '4rem', 
				height: '4rem', 
				backgroundColor: '#eef2f4', 
				border: '2px solid #3a7ebc',
				marginTop: '-1.8rem',
				marginLeft: '-2rem'
			}]} 
			trackStyle={[{backgroundColor: "#3a7ebc"}]}
			onChange={(range) => {props.handleSliderChange(range, props.minName, props.maxName)}} />
		<p className="range-display">
			<span className="range-low">{props.minValue}</span>
			<span>&ndash;</span>
			<span className="range-high">{props.maxValue}</span>
		</p>
	</React.Fragment>
)


// WEBPACK FOOTER //
// ./src/components/RangeSlider/RangeSlider.js